/**
 *
 * @param { } path the path to be stracted
 * @returns [] Array containing the controller in first position and the action a second position
 */

function extractControllerAndActionFromPath(path) {
  var pathWithoutFirstSlash = path.substring(1);
  var controllerAux = pathWithoutFirstSlash.substr(
    0,
    pathWithoutFirstSlash.indexOf("/")
  );
  var actionAux = pathWithoutFirstSlash.substr(
    pathWithoutFirstSlash.indexOf("/") + 1
  );
  return [controllerAux, actionAux];
}

export default extractControllerAndActionFromPath;
